import { MatMenuModule } from "@angular/material/menu";
import { Component, inject } from "@angular/core";
import { UserService } from "../../auth/services/user.service";
import { TokenService } from "../../auth/services/token.service";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HasRoleDirective } from "../../core/directives/has-role.directive";
import { Role } from "../../shared/data-types/roles.enum";
import { MainMenuComponent } from "../main-menu/main-menu.component";
import { BreadcrumbComponent } from "../../shared/components/breadcrumb/breadcrumb.component";
import { filter } from "rxjs";
import { AuthModule } from "../../auth/auth.module";
import { AuthService } from "../../core/services/auth.service";
import { AuthStore } from "../../shared/store/auth.store";

@Component({
  selector: "app-header",
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    RouterModule,
    MatMenuModule,
    MainMenuComponent,
    BreadcrumbComponent,
    CommonModule,
    CommonModule,
    HasRoleDirective,
    AuthModule,
  ],
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
  username: string | null = null;
  Role = Role;
  showBreadcrumb = true;
  showSearch = true;
  showMenu = true;

  private authStore = inject(AuthStore);

  constructor(
    private userService: UserService,
    private tokenService: TokenService,
    private router: Router,
    private authService: AuthService,
  ) {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.showBreadcrumb = !event.urlAfterRedirects.includes("/market") && !event.urlAfterRedirects.includes("/home");
    });
  }

  ngOnInit() {
    this.loadUserData();
  }

  private loadUserData() {
    if (this.tokenService.isTokenValid()) {
      this.username = this.userService.getUsername();
      const isUserAuthenticated = this.authService.isAuthenticated();
      const user = this.authStore.currentUser();
      if (isUserAuthenticated && user?.id === 0) {
        this.authStore.fetchCurrentUser();
      }
    }
  }

  logout() {
    this.tokenService.removeToken();
    this.username = null;
    this.router.navigate(["/auth/login"]);
  }
}
